<div class="mb-promo">
    <HeaderComponent
            :path-image-bck="'2022'"
    />
    <main>
        <section>
            <div class="wide-content-wrapper-cnt">

                <div>
                    <h2 v-html="t('landing.contestFinished')"></h2>

                    <div class="tac">
                        <ButtonComponent
                                :text="t('landing.goToChart')"
                                href="/lacartadelmulino/fiori-del-mulino/2022/home"
                        ></ButtonComponent>
                    </div>
                </div>

                <div class="image-box-container">

                    <ImageBoxComponent
                            v-for="image in paginatedImages"
                            :pid="image.pid"
                            :image-path="image.imgPath"
                            :selected="image.selected"
                            :user-logged="userLogged"
                            :contest-active="contestActive"
                    ></ImageBoxComponent>

                    <div class="load-more-container" v-if="numberTotal">
                        <ButtonComponent type="secondary"
                                         :text="t('landing.showMoreButton')"
                                         @click="loadMore"></ButtonComponent>
                    </div>

                    <ModalComponent></ModalComponent>
                </div>
            </div>
        </section>
    </main>
    <FooterComponent type="homepage"></FooterComponent>
</div>